import type { MinimalUserDto } from '@issuemanager/api-client';
import {
  UserMultipleSelectorField,
  type UserMultipleSelectorFieldProps,
} from '@issuemanager/apps/client/components';
import { FormLabel } from '@mui/material';
import { ReactNode, type JSX } from 'react';
import { useTranslation } from 'react-i18next';

export interface WatchersSelectorProps
  extends Omit<UserMultipleSelectorFieldProps<MinimalUserDto>, 'label'> {
  label: ReactNode;
}

export function WatchersSelector({
  label,
  ...props
}: WatchersSelectorProps): JSX.Element | null {
  const { t } = useTranslation('common');

  return (
    <UserMultipleSelectorField<MinimalUserDto>
      placeholder={t('userSelector.inputPlaceHolder')}
      label={<FormLabel>{label}</FormLabel>}
      {...props}
    />
  );
}
